import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import sectionService from "../../services/section-service";
import dashboardService from "../../services/dashboard-service";
import moment from "moment";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider } from "antd";
import PieChartType from "../DashBoard/PieChartType";
import LineChart from "../DashBoard/LineChart";
import { CloudDownloadOutlined } from "@ant-design/icons";
import config from "../../config/config";
import Select from "react-select";

// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardAverage = () => {


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);
  const chartFourRef = useRef(null);


  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)
  const [averageHectares, setAverageHectares] = useState([]);
  const [listLineAverageData, setListLineAverageData] = useState([]);
  const [listLineAveragePalm, setListLineAveragePalm] = useState([]);

  const [loading, setLoading] = useState(false);

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");

  const [totalFirst, setTotalFirst] = useState(0);
  const [totalSecond, setTotalSecond] = useState(0);
  const [totalThird, setTotalThird] = useState(0);

  registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");


  const [ApplicationByPalm, setApplicationByPalm] = useState(0);
  const [totalHectares, setTotalHectares] = useState(0);
  const [totalPalms, setTotalPalms] = useState(0);
  const [ApplicationByHectare, setApplicationByHectare] = useState(0);


  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////

  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };



  const changeStateShowValues = (e) => {
    setShowLineValues(!e.target.checked)
  }

  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }

  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };



  const getPieData = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setTotalFirst(0);
    setTotalSecond(0);
    setTotalThird(0);
    setLoading(true);
    const result = await dashboardService.getTotalApplicationsByType(start, end, farmId, lotId, sectionId, selectedLotes);
    if (result) {
      if (result.length > 0) {
        setTotalFirst(result[0].totalFirst);
        setTotalSecond(result[0].totalSecond);
        setTotalThird(result[0].totalThird);
        setLoading(false);
      }
    }

  };


  ///APLICACIONES POR DIA
  const getApplicationsByDay = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setAverageHectares([])
    const result = await dashboardService.averageHectares(start, end, farmId, lotId, sectionId, selectedLotes);
    let list = [];
    if (result) {
      result.map((item) => {
        const fecha = formatDate(item._id);
        const cantidad = item.average;
        const rounded = cantidad.toFixed(2);
        list.push({ value: [fecha, rounded] })
      });
    }
    setAverageHectares(list)
  };


  ///PROMEDIO POR OPERARIO  
  const averageByUser = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setListLineAverageData([])
    const result = await dashboardService.averageByUser(start, end, farmId, lotId, sectionId, selectedLotes);
    let list = [];
    if (result) {
      result.map((item) => {
        const fecha = formatDate(item._id);
        const cantidad = item.average;
        const rounded = cantidad.toFixed(0);
        list.push({ value: [fecha, rounded] })
      });
    }
    setListLineAverageData(list)
  };


  ///PROMEDIO POR PALMA  
  const averageByPalm = async () => {
    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setListLineAveragePalm([])
    const result = await dashboardService.averageByPalm(start, end, farmId, lotId, sectionId, selectedLotes,"$total");
    let list = [];
    if (result) {
      result.map((item) => {
        const fecha = formatDate(item._id);
        const cantidad = item.average;
        const rounded = cantidad.toFixed(1);
        list.push({ value: [fecha, rounded] })
      });
    }
    setListLineAveragePalm(list)
  };




  ///APLICACIONES POR LOTE  
  const getIndicatorValues = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

    setApplicationByPalm(0)
    setTotalHectares(0)
    setTotalPalms(0)
    const result = await dashboardService.getIndicatorValues(start, end, farmId, lotId, sectionId, selectedLotes);
    if (result.palms) {
      const palms = result.palms
      setTotalPalms(palms)
      if (result.total && palms > 0) {
        const total = result.total
        const averageByPalm = total / palms
        setApplicationByPalm(averageByPalm)
      }
    }
    if (result.hectares) {
      const hectares = result.hectares
      setTotalHectares(hectares)


      if (result.total && hectares > 0) {
        const total = result.total
        const average = total / hectares
        setApplicationByHectare(average.toFixed(2))
      }

    }

  };






  const loadDashBoard = () => {
    getPieData();
    getApplicationsByDay();
    averageByUser()
    averageByPalm()
    getIndicatorValues();
  };

  useEffect(() => {
    getLisFarm();
    loadDashBoard()
  }, []);

  const {
    register,
    formState: { errors },
  } = useForm();



  const pieData = [
    { value: totalFirst, name: 'Primera' },
    { value: totalSecond, name: 'Segunda' },
    { value: totalThird, name: 'Tercera' },
  ];




  const cardStyle = {
    padding: "18px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };


  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };





  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "18px",
      }}
    >
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Dashboard de promedios</Divider>
      </div>

      <div className="row">
        <div className="col-12">
          <form className="form-react">
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>





              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>

              <div className=" col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráficos
                </button>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>

              <div className="mt-2 col-6 col-sm-2"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeExpand(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Expandir grafica</label>
                </div>
              </div>

              <div className="mt-2 col-6 col-sm-2 d-none"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeStateShowValues(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Ocultar valores</label>
                </div>
              </div>

            </div>



          </form>
        </div>




        <div className="col-12 " style={{ marginTop: "-10px" }}>
          <Divider orientation="left" style={{ border: "#AAAAAA" }} >Indicadores sobre hectáreas de la caracterización seleccionada</Divider>
        </div>
        
        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Hectáreas: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{totalHectares.toLocaleString()}</label>
          </div>
        </div>




        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Palmas: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{totalPalms.toLocaleString()}</label>
          </div>
        </div>




        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Apl/palma: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{ApplicationByPalm.toLocaleString()}</label>
          </div>
        </div>



        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Primera/ha: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{ApplicationByHectare.toLocaleString()}</label>
          </div>
        </div>



        <div className={expandChats ? "col-12" : "col-12 col-sm-6"}>
          <div style={cardStyle}>
            <LineChart
              decimals={0}
              data={listLineAverageData}
              title="Aplicaciones / usuario"
              chartRef={chartOneRef}
              subTitle="Promedio de aplicaciones por usuario"
              seriesTitle="Aplicaciones"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "prom-aplicaciones-usuario.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-12" : "col-12 col-sm-6"}>
          <div style={cardStyle}>
            <LineChart
              decimals={1}
              data={averageHectares}
              chartRef={chartTwoRef}
              title="Hectáreas / usuario"
              subTitle="Promedio de hectáreas recorridas por trabajador"
              seriesTitle="Hectáreas"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartTwoRef, "prom-hectareas-usuario.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>



        <div className={expandChats ? "col-12" : "col-12 col-sm-6 mt-2"}>
          <div style={cardStyle}>
            <LineChart
              decimals={1}
              data={listLineAveragePalm}
              chartRef={chartThreeRef}
              title="Aplicaciones / palma"
              subTitle="Promedio de aplicaciones realizadas por palma"
              seriesTitle="Aplicaciones"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartThreeRef, "prom-aplicaciones-palma.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-12" : "col-12 col-sm-6  mt-2"}>
          <div style={cardStyle}>
            <PieChartType
              data={pieData}
              chartRef={chartFourRef}
              title="Tipo de aplicación"
              subTitle="Acumulado por tipo de aplicación"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartFourRef, "tipo-aplicacion.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>





      </div>
    </div>
  );
};

export default DashboardAverage;
